(function () {
  'use strict';

  if (window.__PetSoNativeBlogLoaded) return;
  window.__PetSoNativeBlogLoaded = true;

  function initSort(root) {
    var select = root.querySelector('[data-petso-blog-sort]');
    var grid = root.querySelector('[data-petso-blog-grid]');
    if (!select || !grid || select.dataset.ready === 'true') return;

    select.dataset.ready = 'true';
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-petso-native-card]'));

    select.addEventListener('change', function () {
      var direction = select.value === 'oldest' ? 1 : -1;
      cards
        .slice()
        .sort(function (a, b) {
          var aDate = Number(a.getAttribute('data-petso-published') || 0);
          var bDate = Number(b.getAttribute('data-petso-published') || 0);
          return (aDate - bDate) * direction;
        })
        .forEach(function (card) {
          grid.appendChild(card);
        });
    });
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-petso-copy-link]').forEach(function (button) {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';

      button.addEventListener('click', function () {
        var url = button.getAttribute('data-copy-url') || window.location.href;
        var label = button.querySelector('[data-petso-copy-label]');

        function showSuccess() {
          if (!label) return;
          var previous = label.textContent;
          label.textContent = 'Copied ✓';
          window.setTimeout(function () {
            label.textContent = previous;
          }, 1800);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(showSuccess).catch(function () {
            window.prompt('Copy this link:', url);
          });
        } else {
          window.prompt('Copy this link:', url);
        }
      });
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-petso-native-blog]').forEach(initSort);
    initCopyButtons(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
